import { eventBus } from "@/lib/event-bus";

export const campaignEventChannel = eventBus<{
  deleteCampaign: (campaignId: string) => void;
  refetchSubscriptions: () => void;
  clockInterval: () => void;
}>();
